import {createContext, useContext} from 'react'

// Provided by ListingsPageModal so an embedded listing card's "Select" reports
// the chosen listing back to the opener (e.g. a DealPage) instead of the default
// standalone/new-tab behavior. `null` everywhere else (standalone ListingsPage,
// CalculatePage drawer), so VehicleCard falls back to its existing flow.
export const ListingsSelectionContext = createContext(null)

export const useListingsSelection = () => useContext(ListingsSelectionContext)
